enum FeatureEnum {
  TM3_CLASSES_ENABLED = 'TM3_CLASSES_ENABLED',
  PRONTO_INTEGRATION = 'PRONTO_INTEGRATION',
  USER_DIARY_RESTRICTION = 'USER_DIARY_RESTRICTION',
  TM3_HEALTHCODE = 'TM3_HEALTHCODE',
  ROLE_MANAGER = 'ROLE_MANAGER',
  TM3_VIDEO_ENABLED = 'TM3_VIDEO_ENABLED',
  CASEFLOW_PREREFERRAL_INFORMATION = 'CASEFLOW_PREREFERRAL_INFORMATION',
  CASEFLOW_PATIENT_PORTAL = 'CASEFLOW_PATIENT_PORTAL',
  CASEFLOW_REFERRAL_PORTAL = 'CASEFLOW_REFERRAL_PORTAL',
  CASEFLOW_EDITABLE_PRICING = 'CASEFLOW_EDITABLE_PRICING',
  MEDIPASS_ACTIVE = 'MEDIPASS_ACTIVE',
  QSW_ENABLED = 'QSW_ENABLED',
  MY_CLINIC_INTEGRATION = 'MY_CLINIC_INTEGRATION',
  UPGRADE_ENABLED = 'UPGRADE_ENABLED',
  FIX_LEGACY_ANNOTATIONS_CONVERSION = 'FIX_LEGACY_ANNOTATIONS_CONVERSION',
  FF_NEW_DOCS_UI = 'FF_NEW_DOCS_UI',
  FF_DIARY_COLOURS = 'FF_DIARY_COLOURS',
  PRONTO_ROADMAP_PHASE_ONE = 'PRONTO_ROADMAP_PHASE_ONE',
  APPOINTMENT_PREPAYMENT = 'APPOINTMENT_PREPAYMENT',
  FF_DX_DASHBOARDS = 'FF_DX_DASHBOARDS',
  FF_ALLOW_CUSTOM_SMS = 'FF_ALLOW_CUSTOM_SMS',
  STOCK_LEVELS = 'FF_STOCK_LEVELS',
  BUSINESS_SETTINGS_RP = 'FF_BUSINESS_SETTINGS_RP',
  WAITING_LIST_PAYMENTS_ENABLED = 'WAITING_LIST_PAYMENTS_ENABLED',
  FF_Embeddable = 'FF_Embeddable',
  FF_BLOCK_EDITOR = 'FF_BLOCK_EDITOR',
  FF_CONNECT_HIDE_FROM_EXPLORE = 'FF_CONNECT_HIDE_FROM_EXPLORE',
  FF_TM3_STRIPE_TERMINALS = 'FF_TM3_STRIPE_TERMINALS',
  FF_TAX_EXEMPTION = 'FF_TAX_EXEMPTION',
  FF_MULTIPLE_CHARGES_PER_APPOINTMENT = 'FF_MULTIPLE_CHARGES_PER_APPOINTMENT',
  FF_DX_LETTER_EDITOR = 'FF_DX_LETTER_EDITOR',
  FF_SSO_ENABLED = 'FF_SSO_ENABLED',
  FF_SSO_GOOGLE = 'FF_SSO_GOOGLE',
  FF_SSO_FACEBOOK = 'FF_SSO_FACEBOOK',
  FF_SSO_MICROSOFT = 'FF_SSO_MICROSOFT',
  FF_SSO_APPLE = 'FF_SSO_APPLE',
  FF_NEW_SEARCH = 'FF_NEW_SEARCH',
  FF_CRM_INTEGRATION = 'FF_CRM_INTEGRATION',
  FF_CONNECT_BOOKING_FLOW_V2 = 'FF_CONNECT_BOOKING_FLOW_V2',
  FF_COMPANION_BOOKINGS = 'FF_COMPANION_BOOKINGS',
  FF_MEDICAL_IMAGING = 'FF_MEDICAL_IMAGING',
  FF_HEALTHCODE_LOOKUP = 'FF_HEALTHCODE_LOOKUP',
  FF_RESTRICT_WORKING_TIME_BY_STOCK = 'FF_RESTRICT_WORKING_TIME_BY_STOCK'
}

export default FeatureEnum;
